import type project from "@core/locales/en/project.json";
import { useTranslation } from "react-i18next";
import { NS } from "@core/libs/i18n/namespaces";

type RecursiveKeyOf<TObj extends object> = {
  [K in keyof TObj & string]: TObj[K] extends object
    ? `${K}.${RecursiveKeyOf<TObj[K]>}`
    : K;
}[keyof TObj & string];

type WorkspaceKeys = RecursiveKeyOf<(typeof project)["workspace"]>;

export const useTranslate = () => {
  const { t: baseT } = useTranslation(NS.PROJECT);

  const t = <K extends WorkspaceKeys>(key: K) =>
    baseT(`workspace.${key}`) as string;

  return { t };
};
